import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'components/atoms/checkbox';
import { SettingsControlPanel } from 'components/molecules/settings/control-panel';
import { useTranslation } from 'hooks/use-translation';
import { useUpdateSettings } from '../use-feature-setting';
import { CheckBoxWrap } from './components';
export const ReasonDescriptionSettings = ({ reasonDescriptionMandatory: defaultReasonDescriptionMandatory })=>{
    const [reasonDescriptionMandatory, setReasonDescriptionMandatory] = useState(defaultReasonDescriptionMandatory);
    const [update] = useUpdateSettings();
    const label = useTranslation('settings.credit_notes.reason_description');
    return /*#__PURE__*/ _jsx(SettingsControlPanel, {
        label: label,
        children: /*#__PURE__*/ _jsx(CheckBoxWrap, {
            children: /*#__PURE__*/ _jsx(Checkbox, {
                checked: reasonDescriptionMandatory,
                onChange: (e)=>{
                    setReasonDescriptionMandatory(e.target.checked);
                    update({
                        payload: {
                            reasonDescriptionMandatory: e.target.checked
                        },
                        onError: ()=>{
                            setReasonDescriptionMandatory(!e.target.checked);
                        }
                    });
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "settings.credit_notes.reason_description.checkbox"
                })
            })
        })
    });
};
